export default "__VITE_ASSET__9e3c8633__"